import { useSlots, computed, capitalize, onMounted, onUpdated, ref, render, h, openBlock, createElementBlock } from "vue";
import { DtNotice } from "@dialpad/dialtone-vue";
const __default__ = {
  name: "DtcRendererTarget"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Component to render.
     */
    component: {
      type: Object,
      required: true
    },
    /**
     * Members to bind to the target component.
     */
    bindings: {
      type: void 0,
      required: true
    },
    /**
     * Events to bind to the target component.
     */
    events: {
      type: void 0,
      required: true
    }
  },
  emits: [
    "event"
  ],
  setup(__props, { emit: __emit }) {
    const ERROR_MESSAGE = "Error rendering component";
    const props = __props;
    const emit = __emit;
    const slots = useSlots();
    const events = computed(() => {
      if (!props.events) {
        return {};
      }
      return Object.fromEntries(
        props.events.map(({ name }) => {
          return [
            `on${capitalize(name)}`,
            (e) => emit("event", name, e)
          ];
        })
      );
    });
    onMounted(renderTarget);
    onUpdated(renderTarget);
    const wrapper = ref();
    function nextContainer() {
      wrapper.value.replaceChildren();
      return wrapper.value.appendChild(document.createElement("div"));
    }
    function renderTarget() {
      const container = nextContainer();
      try {
        render(h(props.component, {
          ...props.bindings,
          ...events.value
        }, slots), container);
      } catch (e) {
        console.warn("Rendering warning: \n", e);
        renderError(e, container);
      }
    }
    function renderError(exception, container) {
      render(h(DtNotice, {
        kind: "error",
        hideClose: true,
        title: ERROR_MESSAGE
      }, {
        default: () => exception.toString()
      }), container);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "wrapper",
        ref: wrapper
      }, null, 512);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=renderer_target.vue.js.map
